import { PlusIcon } from "@heroicons/react/20/solid"
import { useLocation } from "wouter-preact"

export function NewConnectionCard({ next }: { next: string }) {
  const [, setLocation] = useLocation()

  function handleClick() {
    setLocation(next)
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      class="group flex flex-col items-center justify-center p-5 border border-dashed border-gray-300 rounded-lg hover:border-gray-400 hover:bg-gray-50 transition-all cursor-pointer min-h-[120px] w-full">
      <PlusIcon class="h-5 w-5 text-gray-400 group-hover:text-gray-500 mb-1.5 transition-colors" />
      <span class="text-sm text-gray-500 group-hover:text-gray-600 transition-colors">Request New</span>
    </button>
  )
}
